export default {"src":"/_next/static/media/chickpeas.364c94c3.svg","height":480,"width":309,"blurWidth":0,"blurHeight":0};